// src/project/data/fetches/withdrawalAccounts.js
import { buildUrlWithAuth, getUserId, getRiderId } from '../config/apiConfig'

export default {
  url() {
    const userId = getRiderId() || getUserId()
    if (!userId) return 'https://local-mock'
    return buildUrlWithAuth('/accounts/list', {
      service: 'rapidoo',
      userId: userId,
    })
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: 200,
        message: 'Ok',
        data: [],
      }
    }
    const accounts = Array.isArray(raw?.data?.data)
      ? raw.data?.data
      : Array.isArray(raw?.data)
        ? raw.data
        : []
    return {
      statusCode: 200,
      message: 'Ok',
      data: accounts.map(acc => ({
        id: acc.id,
        accountLabel: acc.accountLabel || 'Compte Mobile Money',
        accountNumber: acc.accountNumber || '',
        operator: (acc.operator || 'MTN').toUpperCase(),
        country: acc.country || 'BJ',
        isVerified: acc.isVerified ?? true,
        isSuspended: acc.isSuspended ?? false,
        totalWithdrawal: acc.payoutDetails?.totalWithdrawal || 0,
        createdAt: acc.createdAt,
        updatedAt: acc.updatedAt,
      })),
    }
  },
}
